import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    messageGroupsUser: PropTypes.object.isRequired,
    currentUserId: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      messageGroupsUser: [],
      currentUserId: [],
    };
  },
  fullname_disp(user){
    if (user.is_fullname_hidden && user.is_verified_identity){
      return `@${user.tunagate_id}(本人確認済)`;
    }
    else if (!user.is_fullname_hidden && user.is_verified_identity){
      return  `${user.familyname} ${user.firstname}(本人確認済)`
    }
    else{
      return `${user.familyname} ${user.firstname}`
    }
  },

  render() {
    var currentUserId = this.props.currentUserId;
    var hasAppIcon = "";
    if (
      this.props.messageGroupsUser.user &&
      this.props.messageGroupsUser.user.has_app
    ) {
      hasAppIcon = (
        <span
          className="glyphicon glyphicon-phone"
          aria-hidden="true"
          style={{ fontSize: "0.8em", color: "#1ed45d" }}
        />
      );
    }
    var userBox = "";
    if (
      this.props.messageGroupsUser.user &&
      currentUserId != this.props.messageGroupsUser.user.id
    ) {
      // 使われいない？
      userBox = (
        <div>
          {this.fullname_disp(this.props.messageGroupsUser.user)}さん{hasAppIcon}
        </div>
      );
    }
    return <div style={{ display: "inline-block" }}>{userBox}</div>;
  },
});
